"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showSetting = void 0;
const react_1 = __importDefault(require("react"));
const CopilotSetting_1 = require("./CopilotSetting");
const showSetting = (modalFormFullScreen) => __awaiter(void 0, void 0, void 0, function* () {
    yield modalFormFullScreen({
        title: "翻訳設定",
        children: (react_1.default.createElement("div", null,
            react_1.default.createElement(CopilotSetting_1.CopilotSetting, null))),
    });
});
exports.showSetting = showSetting;
